import Vue from 'vue'
import App from './App'
import router from './router'

import VueAxios from 'vue-axios'
import Vuetify from 'vuetify/lib/framework'
import '@/mixins/helpers'

const AxiosServices = require('./services/axios')

let plainAxiosInstance = null

Vue.config.productionTip = false

fetch(process.env.BASE_URL + 'config.json')
  .then(response => response.json())
  .then(data => {
    console.log('Starting public vue app.')
    Vue.prototype.$config = data
    const opts = {
      theme: {
        themes: {
          light: {
            primary: data.COL_PRIMARY,
            secondary: data.COL_SECONDARY
          }
        }
      }
    }

    Vue.use(Vuetify)

    plainAxiosInstance = AxiosServices.plainAxiosInstance(data.API_URL)

    Vue.use(VueAxios, {
      plain: plainAxiosInstance
    })

    /* eslint-disable no-new */
    new Vue({
      router,
      plainAxiosInstance,
      vuetify: new Vuetify(opts),
      render: h => h(App)
    }).$mount('#app')
  })
  .catch(err => console.log(err))
